module.exports = __webpack_public_path__ + "static/img/1.8168c01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/sp/1.png
// module id = 6oNb
// module chunks = 0